export const getAnalytics = (search_request = '', hints = '') => {
  return {
    click: {
      eventName: 'sport_searchNotResult_clear_click',
      data: {
        сount: hints.length,
        hints,
        search_request,
      },
    },
  };
};
